angular.module('env.i18n.localeName', [])

    .factory('LocaleName', function () {

        /**
         * IETF language tag object
         * @param {string|LocaleName} languageTag - string representation of language tag
         * @constructor
         */
        function LocaleName(languageTag) {

            var me = this;

            /**
             * Default delimiter. '-' by default.
             * @type {string}
             */
            this.defaultDelimiter = "-";

            /**
             * Two-letter language code from ISO 639-1 (2002);
             * Or a three-letter code from ISO 639-2 (1998), ISO 639-3 (2007) or ISO 639-5 (2008)
             * Usually written in lower case
             * @type {string}
             */
            this.language = null;

            /**
             * Four-letter script code from ISO 15924
             * Usually written in title case
             * @type {string}
             */
            this.script = null;

            /**
             * Two-letter country code from ISO 3166-1 alpha-2, usually written in upper case
             * or a three-digit code from UN M.49 for geographical regions;
             * @type {string}
             */
            this.region = null;

            /**
             * Five to eight letters,
             * or four characters starting with a digit;
             * (Variant subtags are registered with IANA and not associated with any external standard.)
             * @type {string}
             */
            this.variant = null;

            //region private members

            /**
             * Convert single word to title case
             * @param {string} word
             * @private
             * @return {string}
             */
            function _toTitleCase(word) {
                return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
            }

            /**
             * Constructor function
             * @param {string} str - language code
             * @private
             */
            function _constructFromString(str) {
                // Regex of short version of IETF standard
                var localeRegEx = /^([a-z]{2,3})(?:[\-_ ]([a-z]{4}))?(?:[\-_ ]((?:[a-z]{1,3})|(?:[0-9]{3})))?(?:[\-_ ]([a-z0-9]{5,8}))?$/i;
                var match = localeRegEx.exec(str);
                if (!match || !match[1]) {
                    throw new Error("String argument is not valid IETF language tag");
                }

                me.language = match[1].toLowerCase();
                me.script = _toTitleCase(match[2] || '');
                me.region = (match[3] || '').toUpperCase();
                me.variant = (match[4] || '').toLowerCase();
            }

            /**
             * Get comparable variants of language (including current form)
             * @param {string} [delimiter] optional delimiter
             * @return {Array}
             * @private
             */
            var _getComparable = function (delimiter) {
                var d = delimiter || me.defaultDelimiter;
                var l = me.language.toLowerCase();
                var s = me.script ? d + _toTitleCase(me.script) : '';
                var r = me.region ? d + me.region.toUpperCase() : '';
                var v = me.variant ? d + me.variant.toLowerCase() : '';

                return _.uniq([ // without duplicates
                    l + s + r + v, // full form
                    l + s + r, // without variant part
                    l + r, // without script part
                    l + s, // with script part only
                    l // pure lang form
                ]);
            };

            //endregion

            //region public members

            /**
             * Convert to string representation
             * @param {string} [delimiter] optional delimiter
             * @returns {string}
             */
            var toString = function (delimiter) {
                var d = delimiter || me.defaultDelimiter;
                return me.language.toLowerCase() +
                    (me.script ? d + _toTitleCase(me.script) : '') +
                    (me.region ? d + me.region.toUpperCase() : '') +
                    (me.variant ? d + me.variant.toLowerCase() : '');
            };

            /**
             * Find the most suitable language from the list
             * @param {Array<string>} availableLanguages - array of available languages
             * @return {string} most suitable language to the current one from input array of available languages
             */
            function getMostSuitableLanguage(availableLanguages) {
                var comparable = _getComparable();
                for (var i = 0; i < comparable.length; i++) {
                    for (var j = 0; j < availableLanguages.length; j++) {
                        if (comparable[i].toLowerCase() == availableLanguages[j].toLowerCase()) {
                            return comparable[i];
                        }
                    }
                }
            }

            //endregion

            if (languageTag && _.isString(languageTag)) {
                _constructFromString(languageTag);
            } else if (languageTag && typeof languageTag == 'LocaleName') {
                _constructFromString(languageTag.toString());
            } else {
                throw new Error("Argument must be string or another LocaleName");
            }

            _.extend(this, {
                toString: toString,
                getMostSuitableLanguage: getMostSuitableLanguage
            });
        }

        return ( LocaleName );
    })

;